<template>
    <div class="container-fluid text-white bg-dark">
        <div class="container text-white bg-dark">
            <div class="row d-flex justify-content-center text-white">
                    <a :href="item.temp_file_name" class="p-4 h5 text-white" v-for="(item,index) in navs" :key="index">{{ item.name }}</a>
            </div>
            <div class="row">
                <div class="col">
                    <div class="p-3" v-if="showFooterInfo">
                        <p class="text-left h6  p-1 text-blod" >公司： {{info.corporate_name}}</p>
                        <p class="text-left h6  p-1" > 地址：{{info.address}}</p>
                        <p class="text-left h6 p-1" ><span class="pr-2">电话：{{info.phone}}</span></p>
                        <p class="text-left h6 p-1" ><span class="pr-2">座机：{{info.telephone}}</span></p>
                    </div>
                </div>
                <div class="col d-flex justify-content-end">
                    <img :src="xiaochengxuImg" class="rounded float-right" style="width: 120px;height: 120px;" alt="...">
                    <img :src="gongzhonghaoImg" class="rounded float-right ml-4" style="width: 120px;height: 120px;" alt="...">
                </div>
            </div>
            <div class="row">
                <div class="col p-3">
                    <p class="text-muted text-center" v-if="showFooterInfo">
                        <a  class="text-reset">{{`Copyright  ©  2022  ${info.corporate_name}  版权所有`}}</a><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" class="text-reset pl-3">{{info.filing_info}}</a>
                    </p>
                </div>
            </div>
        </div>
        
    </div>
  </template>
  
  <script>
//   import qrCode from '@/assets/qrCode.png'
  import xiaochengxu from '@/assets/xiaochengxu.png'
  import gongzhonghao from '@/assets/gongzhonghao.png'

  import { friendLinks } from '@/api/api.js'
  export default {
    name: 'footer-layout',
    props: {
        footer:{
            type:String,
            default(){
                return 'more' // pagination
            }
        },
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        address:{
            type:[Object,Array],
            default(){
                return {
                    name:"西安易企跑数字科技有限公司",
                    address:"公司地址：陕西省西安市高新区锦业路旺都国际D座1205室",
                    telePhone:" 座机：029-8116 8482",
                    mobilePhone:" 电话：133-7922-0232",

                }
             
            }
        },
        footerNavs:{
            type:[Object,Array],
            default(){
                return null
             
            }
        }
    },
    mounted(){
        // this.getFriendLinks()  
    },
    computed:{
        info:function(){
            let info = null
            info = sessionStorage.getItem('basisInfo') ? this.bxDeepClone( JSON.parse(sessionStorage.getItem('basisInfo'))) : null
            return info

        },
        showFooterInfo(){
            let loaded = false
            if(this.info){
                loaded = true
            }
            return loaded 
        },
        navs:function(){
            let list = this.footerNavs || [{
                "no": "LM20230210110001",
                "del_flag": "否",
                "open_type": "本窗口打开",
                "create_time": 1675999630000,
                "modify_user_disp": "王永宏/11000003",
                "modify_user": "wangyh",
                "is_view": "是",
                "website_no": "PCWS202209050001",
                "create_user_disp": "王永宏/11000003",
                "modify_time": 1680835580000,
                "temp_file_name":`/mediaDetails/${'CT23040710460001'}`,
                "is_leaf": "是",
                "path": "/LM20230210110001/",
                "temp_page": "首页",
                "name": "关于我们",
                "id": 20,
                "create_user": "wangyh",
                "seq": 10
                },{
                "no": "LM20230210110002",
                "del_flag": "否",
                "open_type": "本窗口打开",
                "create_time": 1675999630000,
                "modify_user_disp": "王永宏/11000003",
                "modify_user": "wangyh",
                "is_view": "是",
                "website_no": "PCWS202209050001",
                "create_user_disp": "王永宏/11000003",
                "modify_time": 1680835580000,
                "temp_file_name":`/mediaDetails/${'CT23040710590005'}`,
                "is_leaf": "是",
                "path": "/LM20230210110001/",
                "temp_page": "首页",
                "name": "版权声明",
                "id": 20,
                "create_user": "wangyh",
                "seq": 10
                },{
                "no": "LM20230210110003",
                "del_flag": "否",
                "open_type": "本窗口打开",
                "create_time": 1675999630000,
                "modify_user_disp": "王永宏/11000003",
                "modify_user": "wangyh",
                "is_view": "是",
                "website_no": "PCWS202209050001",
                "create_user_disp": "王永宏/11000003",
                "modify_time": 1680835580000,
                "temp_file_name":`/mediaDetails/${'CT23040710550003'}`,
                "is_leaf": "是",
                "path": "/LM20230210110001/",
                "temp_page": "首页",
                "name": "隐私保护",
                "id": 20,
                "create_user": "wangyh",
                "seq": 10
                }]

             return list
        }
    },
    data() {
      return {
        provinceName:"",
        gongzhonghaoImg:gongzhonghao,
        xiaochengxuImg:xiaochengxu
      }
    },
      methods: {
        getFriendLinks(){
            let req = {"serviceName":"srvcms_friend_links_select","colNames":["*"],"condition":[{"colName":"website_no","ruleType":"eq","value":"PCWS202209050001"}],"relation_condition":{},"page":{"pageNo":1,"rownumber":5},"order":[],"draft":false,"query_source":"list_page"}


            friendLinks(req).then((res) =>{
                console.log('----',res)
            })
        },
        getEchartData() {
            
        },
        getEchartProvinceData(province) {
           
            
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  